var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("romanza-default-item", {
    staticClass: "romanza_dessert_item--container",
    attrs: {
      item: _vm.item,
      "pricing-types": _vm.pricingTypes,
      "price-layout": "",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }